import React, { useState } from "react"
import axios from "axios"
import { navigate } from "gatsby"

import { useLocale } from "context/locale"
import { useWindow } from "context/window"

import Input from "components/Input"
import Checkbox from "components/Checkbox"
import Button from "components/Button"

const MediaPressForm = () => {
  const { t } = useLocale()
  const { isBrowser } = useWindow()

  const formID = "59"
  const [send, setSend] = useState(false)
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [legalFirst, setLegalFirst] = useState(false)

  const location = isBrowser ? window.location.href : null

  const formSubmit = e => {
    e.preventDefault()
    setSend(true)

    let formData = new FormData()

    formData.set("firstName", name)
    formData.set("lastName", lastName)
    formData.set("email", email)
    formData.set("message", message)
    formData.set("legalFirst", legalFirst)
    formData.set("pageurl", location)

    axios({
      method: "post",
      url: `https://webinity.zenx.pl/wp-json/contact-form-7/v1/contact-forms/${formID}/feedback/`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(() => {
        navigate(t("/contact-confirmation/"))
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <form onSubmit={formSubmit} className="form">
      <Input
        label={t("Name")}
        placeholder={t("John")}
        type="text"
        id="name"
        name="name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
      />
      <Input
        label={t("Surname")}
        placeholder={t("Doe")}
        type="text"
        id="lastName"
        name="lastName"
        value={lastName}
        onChange={e => setLastName(e.target.value)}
        required
      />
      <Input
        label={t("Email")}
        placeholder={t("john.doe@example.com")}
        type="email"
        id="email"
        name="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
      />
      <Input
        label={t("Message")}
        placeholder={t("Type your message here...")}
        type="textarea"
        id="message"
        name="message"
        value={message}
        onChange={e => setMessage(e.target.value)}
        rows="6"
        required
      />
      <Checkbox
        name="legalFirst"
        checked={legalFirst}
        onChange={() => setLegalFirst(!legalFirst)}
        required
      >
        <span>*</span>
        <div
          dangerouslySetInnerHTML={{
            __html: t(
              "I accept Webinity's <a href='/privacy-policy/'>Privacy Policy</a> and understand that providing the data indicated in the form is voluntary and required to receive an answer to my inquiry."
            ),
          }}
        />
      </Checkbox>

      <p className="form__info">
        <span>*</span> {t("Required field")}
      </p>

      <div className="form__submit">
        <Button
          className="button--small button--blue"
          type="submit"
          disabled={!legalFirst}
        >
          {send === true ? t("Sending...") : t("Send message")}
        </Button>
      </div>
    </form>
  )
}

export default MediaPressForm
